module.exports = __webpack_public_path__ + "img/tu.0974257c.png";